import React, { useState, useEffect } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * generate svg string for watermark
 */
function generateSvg(options) {
    var text = options.text, textColor = options.textColor, textSize = options.textSize, fontFamily = options.fontFamily, lineHeight = options.lineHeight, multiline = options.multiline, opacity = options.opacity, gutter = options.gutter, rotate = options.rotate;
    var rect = calcTextRenderedRect(text, textSize, lineHeight, fontFamily);
    var size = Math.sqrt(rect.width * rect.width + rect.height * rect.height) + gutter * 2;
    var center = size / 2;
    var textContent = text;
    if (multiline) {
        var texts = text.split('\n').map(function (textByLine, index) {
            return "<tspan x='50%' dy='".concat(index === 0 ? '0' : lineHeight, "'>").concat(textByLine, "</tspan>");
        });
        textContent = texts.join('');
    }
    var textEl = "<text fill='".concat(textColor, "' x='50%' y='50%' font-size='").concat(textSize, "' text-anchor='middle' font-family='").concat(fontFamily, "' transform='rotate(").concat(rotate, " ").concat(center, " ").concat(center, ")' opacity='").concat(opacity, "'>").concat(textContent, "</text>");
    return "<svg width='".concat(size, "' height='").concat(size / 1.5, "' xmlns='http://www.w3.org/2000/svg'>").concat(textEl, "</svg>");
}
function calcTextRenderedRect(text, fontSize, lineHeight, fontFamily) {
    var span = document.createElement('span');
    span.innerText = text;
    span.style.fontSize = fontSize + 'px';
    span.style.fontFamily = fontFamily;
    span.style.visibility = 'hidden';
    document.body.appendChild(span);
    var rect = span.getBoundingClientRect();
    document.body.removeChild(span);
    return rect;
}
var watermarkWrapperStyle = {
    position: 'relative'
};
var Watermark = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, text = _a.text, _c = _a.textColor, textColor = _c === void 0 ? '#cccccc' : _c, _d = _a.textSize, textSize = _d === void 0 ? 24 : _d, _e = _a.fontFamily, fontFamily = _e === void 0 ? 'Arial, Helvetica, sans-serif' : _e, _f = _a.opacity, opacity = _f === void 0 ? 0.2 : _f, _g = _a.lineHeight, lineHeight = _g === void 0 ? '1.2rem' : _g, _h = _a.multiline, multiline = _h === void 0 ? false : _h, wrapperStyle = _a.wrapperStyle, _j = _a.wrapperElement, wrapperElement = _j === void 0 ? 'div' : _j, _k = _a.gutter, gutter = _k === void 0 ? 0 : _k, _l = _a.rotate, rotate = _l === void 0 ? -45 : _l, _m = _a.zIndex, zIndex = _m === void 0 ? 1 : _m, children = _a.children;
    var _o = useState(''), backgroundImage = _o[0], setBackgroundImage = _o[1];
    useEffect(function () {
        var svg = generateSvg({ text: text, textColor: textColor, textSize: textSize, fontFamily: fontFamily, opacity: opacity, gutter: gutter, rotate: rotate, multiline: multiline, lineHeight: lineHeight });
        var convertedSvg = encodeURIComponent(svg)
            .replace(/'/g, '%27')
            .replace(/"/g, '%22');
        setBackgroundImage("url(\"data:image/svg+xml,".concat(convertedSvg, "\")"));
    }, [show, text, textColor, textSize, opacity, gutter, rotate]);
    var watermarkStyle = {
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        content: '',
        backgroundRepeat: 'repeat',
        zIndex: zIndex,
        backgroundImage: backgroundImage
    };
    var Wrapper = wrapperElement;
    return (React.createElement(Wrapper, { style: __assign(__assign({}, watermarkWrapperStyle), wrapperStyle) },
        show && React.createElement("div", { style: watermarkStyle }),
        children));
};

export { Watermark };
//# sourceMappingURL=index.esm.js.map
